var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "py-4 flex", attrs: { id: `question_${_vm.index + 1}` } },
    [
      _c(
        "span",
        {
          staticClass:
            "w-20 py-5 px-6 text-3xl leading-relaxed absolute transform -translate-y-3 lg:translate-y-0",
          class: { [_vm.correctClass]: _vm.examTypeQuiz },
        },
        [_vm._v(_vm._s(_vm.index + 1))]
      ),
      _c(
        "div",
        {
          class: [
            "min-w-0 py-3 flex-1 lg:pl-20 lg:py-5",
            [_vm.isMobile ? "pl-20" : "pl-14"],
          ],
        },
        [
          [
            _c(
              "div",
              { staticClass: "-ml-20 pl-20 flex items-start gap-x-1" },
              [
                _c(
                  "p",
                  { staticClass: "w-full rounded-lg py-2.5 px-5 bg-gray-100" },
                  [_vm._v(_vm._s(_vm.question.questionTitle))]
                ),
                _vm.examTypeQuiz
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-x-1" },
                      [
                        _c("GrmTextField", {
                          staticClass: "w-20",
                          attrs: {
                            type: "number",
                            value: _vm.question.questionScore,
                            disabled: "",
                          },
                        }),
                        _c("span", { staticClass: "text-xs" }, [
                          _vm._v(_vm._s(_vm.$t("exam.question.point"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ],
          _c(
            "div",
            { staticClass: "mt-2 flex flex-col gap-y-2" },
            [
              _vm._l(_vm.question.answerList, function (answer) {
                return _c(
                  "div",
                  {
                    key: answer.answerId,
                    staticClass: "flex items-start gap-x-1",
                  },
                  [
                    answer.answerText
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "rounded-lg p-4 bg-blue-50 text-sm break-all",
                          },
                          [_vm._v(_vm._s(answer.answerText))]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              _vm._l(_vm.question.userAnswerList, function (userAnswer) {
                return _c(
                  "div",
                  {
                    key: userAnswer.userAnswerId,
                    staticClass: "flex items-start",
                  },
                  [
                    _c(
                      "p",
                      {
                        staticClass:
                          "border border-blue-400 rounded-lg p-4 text-sm break-all",
                      },
                      [_vm._v(_vm._s(userAnswer.answerText))]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }